import { Rect } from "react-konva";

const MenuSpacer = (props: { height: number }) => {
  return <Rect height={props.height} opacity={0} />;
};

export default MenuSpacer;
